import React from "react";
import Close from "@mui/icons-material/Close";
import classes from "./Modal.module.scss";
import ReactStars from "react-stars";
import InformationContainer from "../../NewProposalDesign/InformationContainer";
import {
    Beds,
    CommentSvg,
    FeatureSvg,
    Goto,
    Occupancy,
} from "../../../constants/resources";
import {
    AccommodationFlight,
    AccommodationRoomDetail,
    ItineraryAccommodation,
    itinerary,
} from "../../../atom/Types";
import { selectArray } from "../../NewProposalDesign/VeryNewProposlDesign";
import { checkSpacing } from "../../../atom/utilities/function";
import CachedLink from "../../CachedLink";

interface props {
    activeAccomodation?: ItineraryAccommodation;
    setAccomodationModal: React.Dispatch<React.SetStateAction<boolean>>;
    buliddata: itinerary;
    setbuilddata: React.Dispatch<React.SetStateAction<itinerary | undefined>>;
    selectArray: selectArray[];
    setSelectedArray: React.Dispatch<React.SetStateAction<selectArray[]>>;
}
const AccommodationModal: React.FC<props> = ({
    activeAccomodation,
    setAccomodationModal,
    buliddata,
    setbuilddata,
    selectArray,
    setSelectedArray,
}) => {

    const handleDesable = (acc: ItineraryAccommodation) => {


        let selected = true;
        if (acc.roomDetails.length > 0) {
            acc?.roomDetails?.forEach((room) => {
                if (room.selected) {
                    return (selected = false);
                }
            });
        } else if (acc.accommodationRooms.length > 0) {
            acc?.accommodationRooms?.forEach((room) => {
                if (room.selected) {
                    return (selected = false);
                }
            });
        } else {
            acc?.accommodationRoom?.forEach((room) => {
                if (room.selected) {
                    return (selected = false);
                }
            });
        }

        return selected;
    };

    const handleAccomadationChoose = (
        node: ItineraryAccommodation | undefined
    ) => {

        if (node !== undefined) {
            const updateData = { ...buliddata };
            const array = [...selectArray];
            if (buliddata.type === 'Proposal') {
                updateData?.proposalView &&
                    updateData?.proposalView[node.ind ? node.ind : -1]?.value
                        ?.filter((n) => n.type === "accommodation")
                        .forEach((accommodations) => {

                            if (!handleDesable(node)) {
                                if (accommodations.id === node.id) {
                                    accommodations.selected = true;
                                } else {
                                    accommodations.selected = false;
                                    if (
                                        "roomDetails" in accommodations &&
                                        accommodations.roomDetails.length > 0
                                    ) {
                                        accommodations?.roomDetails.forEach((selectedRooms) => {
                                            selectedRooms.selected = false;
                                        });
                                    }
                                    if (
                                        "accommodationRooms" in accommodations &&
                                        accommodations.accommodationRooms.length > 0
                                    ) {
                                        accommodations?.accommodationRooms?.forEach(
                                            (selectedRooms) => {
                                                selectedRooms.selected = false;
                                            }
                                        );
                                    }
                                    if (
                                        "accommodationRoom" in accommodations &&
                                        accommodations.accommodationRoom !== null
                                    ) {
                                        accommodations?.accommodationRoom?.forEach(
                                            (selectedRooms) => {
                                                selectedRooms.selected = false;
                                            }
                                        );
                                    }
                                }

                                if (accommodations.selected === true) {

                                    array.push({
                                        location:
                                            updateData?.proposalView &&
                                            updateData?.proposalView[node.ind ? node.ind : -1].location,
                                        data: node,
                                    });
                                    setSelectedArray([...array]);
                                } else if (accommodations.selected === false) {
                                    const index = array.findIndex(
                                        (n) => n.data.id === accommodations.id
                                    );

                                    if (index > -1) {
                                        array.splice(index, 1);
                                        setSelectedArray([...array]);
                                    }
                                }
                            } else if (accommodations.id === node.id) {
                                const index = array.findIndex(
                                    (n) => n.data.id === accommodations.id
                                );

                                if (index > -1) {
                                    array.splice(index, 1);
                                    setSelectedArray([...array]);
                                }
                                accommodations.selected = false;
                            }
                        })
                let tempFlights = updateData?.proposalView?.filter((node) => {
                    return node?.value.length > 0;
                });
                let unavailableFlights: AccommodationFlight[] = [];


                array
                    .filter((n) => {
                        return (
                            "accommodationFlights" in n?.data &&
                            n?.data?.accommodationFlights?.length > 0
                        );
                    })
                    .forEach((n) => {
                        "accommodationFlights" in n?.data &&
                            n?.data?.accommodationFlights.forEach((fli) => {
                                return unavailableFlights.push(fli);
                            });
                    });
                tempFlights?.map((node) =>
                    node?.value.forEach((flight) => {
                        if (flight?.type === "flight" && "visibility" in flight) {
                            unavailableFlights.forEach((element) => {
                                if (element?.id === flight?.id) {
                                    flight.visibility = false;
                                    flight.selected = false;
                                } else flight.visibility = true;
                            });
                        }
                        if (unavailableFlights.length === 0 && "visibility" in flight) {
                            flight.visibility = true;
                        }
                    })
                );
            }
            else {
                updateData?.days &&
                    updateData?.days[node.day ? node.day - 1 : -1]?.sorted
                        ?.filter((n) => n.type === "accommodation")
                        .forEach((accommodations) => {

                            if (!handleDesable(node)) {
                                if (accommodations.id === node.id) {
                                    accommodations.selected = true;
                                } else {
                                    accommodations.selected = false;
                                    if (
                                        "roomDetails" in accommodations &&
                                        accommodations.roomDetails.length > 0
                                    ) {
                                        accommodations?.roomDetails.forEach((selectedRooms) => {
                                            selectedRooms.selected = false;
                                        });
                                    }
                                    if (
                                        "accommodationRooms" in accommodations &&
                                        accommodations.accommodationRooms.length > 0
                                    ) {
                                        accommodations?.accommodationRooms?.forEach(
                                            (selectedRooms) => {
                                                selectedRooms.selected = false;
                                            }
                                        );
                                    }
                                    if (
                                        "accommodationRoom" in accommodations &&
                                        accommodations.accommodationRoom !== null
                                    ) {
                                        accommodations?.accommodationRoom?.forEach(
                                            (selectedRooms) => {
                                                selectedRooms.selected = false;
                                            }
                                        );
                                    }
                                }

                                if (accommodations.selected === true) {

                                    array.push({
                                        location:
                                            node.day?.toString(),
                                        data: node,
                                    });
                                    setSelectedArray([...array]);
                                } else if (accommodations.selected === false) {
                                    const index = array.findIndex(
                                        (n) => n.data.id === accommodations.id
                                    );

                                    if (index > -1) {
                                        array.splice(index, 1);
                                        setSelectedArray([...array]);
                                    }
                                }
                            } else if (accommodations.id === node.id) {
                                const index = array.findIndex(
                                    (n) => n.data.id === accommodations.id
                                );

                                if (index > -1) {
                                    array.splice(index, 1);
                                    setSelectedArray([...array]);
                                }
                                accommodations.selected = false;
                            }
                        })
            }


            setbuilddata({ ...updateData });
            setAccomodationModal(false);
        }
    };

    const handleRoomtype = (nodeeee: AccommodationRoomDetail, index: number) => {


        let flagCount = 0;
        const updateData: itinerary = { ...buliddata };
        if (buliddata.type === 'Proposal') {
            if (
                activeAccomodation &&
                updateData?.proposalView &&
                activeAccomodation?.roomDetails?.length > 0
            ) {
                updateData?.proposalView[index]?.value
                    ?.filter((node) => node.type === "accommodation")
                    .forEach((rooms) => {
                        if ("roomDetails" in rooms)
                            rooms?.roomDetails.forEach((selectedRooms) => {
                                if (selectedRooms.id === nodeeee?.id) {
                                    selectedRooms.selected = !selectedRooms.selected;
                                } else if (!activeAccomodation.selected && index === -1) {
                                    const index = activeAccomodation?.roomDetails.findIndex(
                                        (n) => n.id === selectedRooms.id
                                    );
                                    if (index > -1) {
                                        selectedRooms.selected = false;
                                    }
                                }
                            });
                    });
            } else if (
                activeAccomodation &&
                updateData?.proposalView &&
                activeAccomodation.accommodationRooms.length > 0
            ) {
                updateData?.proposalView[index]?.value
                    ?.filter((node) => node.type === "accommodation")
                    .forEach((rooms) => {
                        if ("accommodationRooms" in rooms)
                            rooms?.accommodationRooms.forEach((selectedRooms) => {
                                if (selectedRooms.id === nodeeee?.id) {
                                    selectedRooms.selected = !selectedRooms.selected;
                                } else if (!activeAccomodation.selected && index === -1) {
                                    const index = activeAccomodation?.accommodationRooms.findIndex(
                                        (n) => n.id === selectedRooms.id
                                    );
                                    if (index > -1) {
                                        selectedRooms.selected = false;
                                    }
                                }
                            });
                    });
            } else {
                updateData?.proposalView &&
                    updateData?.proposalView[index]?.value
                        ?.filter((node) => node.type === "accommodation")
                        .forEach((rooms) => {
                            if ("accommodationRoom" in rooms)
                                rooms?.accommodationRoom.forEach((selectedRooms) => {
                                    if (selectedRooms.id === nodeeee?.id) {
                                        selectedRooms.selected = !selectedRooms.selected;
                                    } else if (
                                        activeAccomodation &&
                                        !activeAccomodation.selected &&
                                        index === -1
                                    ) {
                                        const index = activeAccomodation?.accommodationRoom.findIndex(
                                            (n) => n.id === selectedRooms.id
                                        );
                                        if (index > -1) {
                                            selectedRooms.selected = false;
                                        }
                                    }
                                });
                        });
            }
        }
        else {
            if (
                activeAccomodation &&
                updateData?.days &&
                activeAccomodation?.roomDetails?.length > 0
            ) {
                updateData?.days[index - 1]?.sorted
                    ?.filter((node) => node.type === "accommodation")
                    .forEach((rooms) => {


                        if ("roomDetails" in rooms)
                            rooms?.roomDetails.forEach((selectedRooms) => {
                                if (selectedRooms.id === nodeeee?.id) {
                                    selectedRooms.selected = !selectedRooms.selected;
                                } else if (!activeAccomodation.selected && index === -1) {
                                    const index = activeAccomodation?.roomDetails.findIndex(
                                        (n) => n.id === selectedRooms.id
                                    );
                                    if (index > -1) {
                                        selectedRooms.selected = false;
                                    }
                                }
                            });
                    });
            } else if (
                activeAccomodation &&
                updateData?.days &&
                activeAccomodation.accommodationRooms.length > 0
            ) {
                updateData?.days[index - 1]?.sorted
                    ?.filter((node) => node.type === "accommodation")
                    .forEach((rooms) => {
                        if ("accommodationRooms" in rooms)
                            rooms?.accommodationRooms.forEach((selectedRooms) => {
                                if (selectedRooms.id === nodeeee?.id) {
                                    selectedRooms.selected = !selectedRooms.selected;
                                } else if (!activeAccomodation.selected && index === -1) {
                                    const index = activeAccomodation?.accommodationRooms.findIndex(
                                        (n) => n.id === selectedRooms.id
                                    );
                                    if (index > -1) {
                                        selectedRooms.selected = false;
                                    }
                                }
                            });
                    });
            } else {
                updateData?.days &&
                    updateData?.days[index - 1]?.sorted
                        ?.filter((node) => node.type === "accommodation")
                        .forEach((rooms) => {
                            if ("accommodationRoom" in rooms)
                                rooms?.accommodationRoom.forEach((selectedRooms) => {
                                    if (selectedRooms.id === nodeeee?.id) {
                                        selectedRooms.selected = !selectedRooms.selected;
                                    } else if (
                                        activeAccomodation &&
                                        !activeAccomodation.selected &&
                                        index === -1
                                    ) {
                                        const index = activeAccomodation?.accommodationRoom.findIndex(
                                            (n) => n.id === selectedRooms.id
                                        );
                                        if (index > -1) {
                                            selectedRooms.selected = false;
                                        }
                                    }
                                });
                        });
            }

        }

        activeAccomodation && activeAccomodation.roomDetails.length > 0
            ? activeAccomodation.roomDetails.forEach((n) => {
                return n.selected ? (flagCount = flagCount + 1) : flagCount;
            })
            : activeAccomodation && activeAccomodation.accommodationRooms.length > 0
                ? activeAccomodation.accommodationRooms.forEach((n) => {
                    return n.selected ? (flagCount = flagCount + 1) : flagCount;
                })
                : activeAccomodation && activeAccomodation.accommodationRoom.length > 0
                    ? activeAccomodation.accommodationRoom.forEach((n) => {
                        return n.selected ? (flagCount = flagCount + 1) : flagCount;
                    })
                    : (flagCount = 10);

        setbuilddata({ ...updateData });
    };

    const handleClick = () => {
        setAccomodationModal(false);
        let updateData = { ...buliddata }
        if (activeAccomodation && (activeAccomodation.day || activeAccomodation?.ind))
            if (buliddata.type === 'Proposal' && updateData.proposalView) {
                updateData?.proposalView[activeAccomodation?.ind ? activeAccomodation?.ind : -1].value.filter((node) => {
                    return (node.id === activeAccomodation.id && !activeAccomodation.selected)
                }).forEach((rooms) => {
                    if ("roomDetails" in rooms && rooms.roomDetails.length > 0)
                        rooms?.roomDetails.forEach((selectedRooms) => {
                            selectedRooms.selected = false
                        });
                    else if ("accommodationRooms" in rooms && rooms.accommodationRooms.length > 0)
                        rooms?.accommodationRooms.forEach((selectedRooms) => {
                            selectedRooms.selected = false
                        })
                    else {
                        if ("accommodationRoom" in rooms && rooms.accommodationRoom.length > 0)
                            rooms?.accommodationRoom.forEach((selectedRooms) => {
                                selectedRooms.selected = false
                            })
                    }
                })
            }
            else {
                updateData?.days[activeAccomodation.day ? activeAccomodation.day - 1 : -1].sorted?.filter((node) => {
                    return (node.id === activeAccomodation.id && !activeAccomodation.selected)
                }).forEach((rooms) => {
                    if ("roomDetails" in rooms && rooms.roomDetails.length > 0)
                        rooms?.roomDetails.forEach((selectedRooms) => {
                            selectedRooms.selected = false
                        });
                    else if ("accommodationRooms" in rooms && rooms.accommodationRooms.length > 0)
                        rooms?.accommodationRooms.forEach((selectedRooms) => {
                            selectedRooms.selected = false
                        })
                    else {
                        if ("accommodationRoom" in rooms && rooms.accommodationRoom.length > 0)
                            rooms?.accommodationRoom.forEach((selectedRooms) => {
                                selectedRooms.selected = false
                            })
                    }
                })
            }
        setbuilddata(updateData)
    };




    return (
        <div className={classes.ModalBackground}>
            <div className={classes.ModalContent}>
                <div className={classes.ModalStart}>
                    <div
                        className={
                            activeAccomodation?.accommodation?.website
                                ? classes.modalTop
                                : classes.modalTopSpec
                        }
                    >
                        <>
                            {activeAccomodation?.accommodation?.website ? (
                                <CachedLink
                                    href={activeAccomodation?.accommodation?.website}
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    website
                                    <Goto />
                                </CachedLink>
                            ) : null}
                        </>
                        <div className={classes.modalTopSpec}>
                            <button
                                disabled={activeAccomodation && activeAccomodation.selected}
                                className={classes.CloseButton}
                                onClick={() => handleClick()}
                            >
                                <Close className={classes.closesvg} />
                            </button>
                        </div>
                    </div>
                    <div className={classes.accHead}>
                        <div>
                            <div className={classes.header}>
                                {activeAccomodation?.accommodation?.name}
                            </div>
                            {activeAccomodation?.accommodation?.rating ? (
                                <div style={{ display: "flex" }}>
                                    <>
                                        {activeAccomodation?.accommodation?.rating
                                            .replace("R", "")
                                            .replace("_", ".")}
                                    </>
                                    <div style={{ position: "relative", top: "-8px" }}>
                                        <ReactStars
                                            count={1}
                                            value={1}
                                            edit={false}
                                            // onChange={ratingChanged}
                                            size={24}
                                            color1={"#E0E6ED"}
                                            color2={"#FFC700"}
                                        />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div />
                    </div>
                    <hr />

                    <div className={classes.modalHeight}>
                        <InformationContainer
                            data={activeAccomodation?.accommodation}
                        />
                        {activeAccomodation &&
                            activeAccomodation?.roomDetails.length > 0 ? (
                            <>
                                {activeAccomodation?.roomDetails.map(
                                    (node, index) => (
                                        <div key={index}
                                            className={
                                                node?.selected
                                                    ? classes.roomBodySelected
                                                    : classes.roomBody
                                            }
                                        >
                                            <div className={classes.descDetails}>
                                                {node?.roomDetail?.media.length > 0 ? (
                                                    <div className={classes.roomImage}>
                                                        <img
                                                            src={node?.roomDetail?.media[0].url}
                                                            alt="img"
                                                        />
                                                    </div>
                                                ) : null}
                                                <div className={classes.roomImagehead}>
                                                    {node?.roomDetail?.name ? (
                                                        <div className={classes.subHeader}>
                                                            {node?.roomDetail?.name}
                                                        </div>
                                                    ) : null}
                                                    {node?.roomDetail?.maxOccupancy !== "" &&
                                                        node?.roomDetail?.maxOccupancy !== " " &&
                                                        node?.roomDetail?.maxOccupancy ? (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <FeatureSvg />
                                                            </div>
                                                            <div className={classes.InfoText}>
                                                                Max Occupancy of{" "}
                                                                {node?.roomDetail?.maxOccupancy}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <FeatureSvg />
                                                            </div>
                                                            <div className={classes.emptyInfoText}>
                                                                Max Occupancy of{" "}
                                                                {node?.roomDetail?.maxOccupancy}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {node?.roomDetail.size !== "" &&
                                                        node?.roomDetail?.size !== " " &&
                                                        node?.roomDetail?.size ? (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <FeatureSvg />
                                                            </div>
                                                            <div className={classes.InfoText}>
                                                                {node?.roomDetail?.size} in size
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <FeatureSvg />
                                                            </div>
                                                            <div className={classes.emptyInfoText}>
                                                                Size information not available{" "}
                                                                {node?.roomDetail?.maxOccupancy}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {node?.roomDetail?.beds !== "" &&
                                                        node?.roomDetail?.beds !== " " &&
                                                        node?.roomDetail?.beds ? (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <FeatureSvg />
                                                            </div>
                                                            <div className={classes.InfoText}>
                                                                {node?.roomDetail.beds}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <FeatureSvg />
                                                            </div>
                                                            <div className={classes.emptyInfoText}>
                                                                {" "}
                                                                Beds information not available{" "}
                                                                {node?.roomDetail?.maxOccupancy}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {node?.price !== null &&
                                                        node.price !== 0 ? (
                                                        <div className={classes.roomPrice}>
                                                            <p className={classes.subHeader}>Price</p>
                                                            <table>
                                                                <tr>
                                                                    <td>Nights</td>
                                                                    <td
                                                                        style={{
                                                                            fontSize: "16px",
                                                                            color: "var(--black, #273443)",
                                                                        }}
                                                                        colSpan={2}
                                                                    >
                                                                        {activeAccomodation?.days &&
                                                                            activeAccomodation?.days[2]}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Total</td>
                                                                    <td
                                                                        style={{
                                                                            fontSize: "14px",
                                                                            color: "var(--Blue-text, #0279CF)",
                                                                        }}
                                                                        colSpan={2}
                                                                    >
                                                                        ${(node?.count ? node.count : 1) * (node?.price ? node.price : 0)}
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </div>
                                                    ) : null}
                                                    {checkSpacing(node.comment) && node.comment ? (
                                                        <p
                                                            className={classes.roomComment}
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    checkSpacing(node?.comment) ? node?.comment : "",
                                                            }}
                                                        ></p>

                                                    ) : null}
                                                </div>
                                            </div>
                                            <br />
                                            {node.selected ? (
                                                <div className={classes.ClearChoiceroom}>
                                                    {/* disabled={activeAccomodation.selected && count === 1 ? true : false} */}
                                                    <button
                                                        onClick={() => {
                                                            buliddata.type === 'Proposal' ? handleRoomtype(
                                                                node, (activeAccomodation?.ind ? activeAccomodation.ind : -1))
                                                                : handleRoomtype(node, activeAccomodation?.day ? activeAccomodation.day : -1)
                                                        }}
                                                    >
                                                        <Close className={classes.buttonCloseSvg} />
                                                        Clear choice
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className={classes.Chooseroom}>
                                                    <button
                                                        onClick={() => {
                                                            buliddata.type === 'Proposal' ? handleRoomtype(
                                                                node, (activeAccomodation?.ind ? activeAccomodation.ind : -1))
                                                                : handleRoomtype(node, activeAccomodation?.day ? activeAccomodation.day : -1)
                                                        }}
                                                    >
                                                        Add to itinerary
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    )
                                )}
                            </>
                        ) : activeAccomodation &&
                            activeAccomodation?.accommodationRooms.length > 0 ? (
                            <>
                                {activeAccomodation?.accommodationRooms.map(
                                    (node: any, index) => (
                                        <div key={index}
                                            className={
                                                node?.selected
                                                    ? classes.roomBodySelected
                                                    : classes.roomBody
                                            }
                                        >
                                            <div className={classes.descDetails}>
                                                {node?.media[0]?.url ? (
                                                    <div className={classes.roomImage}>
                                                        <img src={node?.media[0]?.url} alt="roomImage" />
                                                    </div>
                                                ) : null}
                                                <div
                                                    style={{ display: "flex", flexDirection: "column" }}
                                                >
                                                    {node?.name ? (
                                                        <div className={classes.subHeader}>
                                                            {node?.name}
                                                        </div>
                                                    ) : null}
                                                    {node?.maxOccupancy !== "" &&
                                                        node?.maxOccupancy !== " " &&
                                                        node?.maxOccupancy ? (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <Occupancy />
                                                            </div>
                                                            <div className={classes.InfoText}>
                                                                Sleeps {node?.maxOccupancy}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <FeatureSvg />
                                                            </div>
                                                            <div className={classes.emptyInfoText}>
                                                                Max Occupancy information not available
                                                            </div>
                                                        </div>
                                                    )}

                                                    {node?.size !== "" &&
                                                        node?.size !== " " &&
                                                        node?.size ? (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <FeatureSvg />
                                                            </div>
                                                            <div className={classes.InfoText}>
                                                                {node?.size} in size
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <FeatureSvg />
                                                            </div>
                                                            <div className={classes.emptyInfoText}>
                                                                Size information not available{" "}
                                                                {node?.roomDetail?.maxOccupancy}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {node?.beds !== "" &&
                                                        node?.beds !== " " &&
                                                        node?.beds ? (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <Beds />
                                                            </div>
                                                            <div className={classes.InfoText}>
                                                                {node?.beds}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className={classes.AccomodationFeature}>
                                                            <div className={classes.featureIcon}>
                                                                <FeatureSvg />
                                                            </div>
                                                            <div className={classes.emptyInfoText}>
                                                                {" "}
                                                                Beds information not available{" "}
                                                                {node?.roomDetail?.maxOccupancy}
                                                            </div>
                                                        </div>
                                                    )}
                                                    {node?.roomAmenities?.map((nodee: any) => {
                                                        return (
                                                            <div className={classes.AccomodationFeature}>
                                                                <div className={classes.featureIcon}>
                                                                    <img
                                                                        src={nodee.image}
                                                                        width="15"
                                                                        height="14"
                                                                        alt="amenities"
                                                                    ></img>
                                                                </div>
                                                                <div className={classes.InfoText}>
                                                                    {nodee.type}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                <br />
                                                {node?.comment ? (
                                                    <div className={classes.AccomodationFeature}>
                                                        <div className={classes.featureIcon}>
                                                            <CommentSvg />
                                                        </div>
                                                        <div className={classes.InfoText}>
                                                            {node?.comment}
                                                        </div>
                                                    </div>
                                                ) : null}
                                                <br />
                                            </div>
                                            <div />
                                            {node.selected ? (
                                                <div className={classes.ClearChoiceroom}>
                                                    {/* disabled={activeAccomodation.selected && count === 1 ? true : false} */}
                                                    <button
                                                        onClick={() => {
                                                            handleRoomtype(
                                                                node,
                                                                activeAccomodation.day
                                                                    ? activeAccomodation?.day
                                                                    : -1
                                                            );
                                                        }}
                                                    >
                                                        <Close className={classes.buttonCloseSvg} />
                                                        Clear choice
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className={classes.Chooseroom}>
                                                    <button
                                                        onClick={() => {
                                                            handleRoomtype(
                                                                node,
                                                                activeAccomodation.day
                                                                    ? activeAccomodation?.day
                                                                    : -1
                                                            );
                                                        }}
                                                    >
                                                        Add to itinerary
                                                    </button>
                                                </div>
                                            )}
                                            <br />
                                        </div>
                                    )
                                )}
                            </>
                        ) : activeAccomodation?.accommodationRoom ? (
                            <>
                                {activeAccomodation?.accommodationRoom.map(
                                    (node: any, index: any) => (
                                        <>
                                            <div className={classes.subHeader}>{node?.name}</div>
                                            <div style={{ display: "flex", flexDirection: "column" }}>
                                                {node?.maxOccupancy !== "" &&
                                                    node?.maxOccupancy !== " " &&
                                                    node?.maxOccupancy ? (
                                                    <div className={classes.AccomodationFeature}>
                                                        <div className={classes.featureIcon}>
                                                            <FeatureSvg />
                                                        </div>
                                                        <div className={classes.InfoText}>
                                                            Max Occupancy of {node?.maxOccupancy}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className={classes.AccomodationFeature}>
                                                        <div className={classes.featureIcon}>
                                                            <FeatureSvg />
                                                        </div>
                                                        <div className={classes.emptyInfoText}>
                                                            {" "}
                                                            MaxOccupancy information not available
                                                        </div>
                                                    </div>
                                                )}

                                                {node?.size !== "" &&
                                                    node?.size !== " " &&
                                                    node?.size ? (
                                                    <div className={classes.AccomodationFeature}>
                                                        <div className={classes.featureIcon}>
                                                            <FeatureSvg />
                                                        </div>
                                                        <div className={classes.InfoText}>
                                                            {node?.size} in size
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className={classes.AccomodationFeature}>
                                                        <div className={classes.featureIcon}>
                                                            <FeatureSvg />
                                                        </div>
                                                        <div className={classes.emptyInfoText}>
                                                            {" "}
                                                            Size information not available{" "}
                                                            {node?.roomDetail?.maxOccupancy}
                                                        </div>
                                                    </div>
                                                )}

                                                {node?.beds !== "" &&
                                                    node?.beds !== " " &&
                                                    node?.beds ? (
                                                    <div className={classes.AccomodationFeature}>
                                                        <div className={classes.featureIcon}>
                                                            <FeatureSvg />
                                                        </div>
                                                        <div className={classes.InfoText}>{node?.beds}</div>
                                                    </div>
                                                ) : (
                                                    <div className={classes.AccomodationFeature}>
                                                        <div className={classes.featureIcon}>
                                                            <FeatureSvg />
                                                        </div>
                                                        <div className={classes.emptyInfoText}>
                                                            {" "}
                                                            Beds information not available{" "}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </>
                                    )
                                )}
                            </>
                        ) : (
                            <div className={classes.AccomodationFeature}>
                                <div className={classes.featureIcon}>
                                    <FeatureSvg />
                                </div>
                                <div className={classes.emptyInfoText}>
                                    {" "}
                                    No room information available{" "}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {
                    <div className={classes.Choose}>
                        <button
                            onClick={() => handleAccomadationChoose(activeAccomodation)}
                        >
                            Confirm
                        </button>
                    </div>
                }
            </div>
        </div>
    );
};

export default AccommodationModal;
